<p>
  html-scroll-wheel works! The key thing here is that the mouse has to be over the page.
</p>
<div appMouseWheel (mouseWheelUp)="mouseWheelUpFunc($event)" (mouseWheelDown)="mouseWheelDownFunc($event)" style="height:1500px; width:100%">
  {{_ScrollCount}}
</div>